import { API_PREFIX_BUYER, API_PREFIX_SUPPLIER, API_ROUTES, API_VERSION } from "./api-routes";

export const environment = {
	appVersion: require('../../package.json').version,
	production: true,
	env: "prod",
	API_ENDPOINT: "https://api-bespin.tenderpilot.de",
	FRONTEND_URL: "https://app.tenderpilot.de",
	VERSION_V1: API_VERSION,
	API_ROUTES: API_ROUTES,
	API_PREFIX_BUYER: API_PREFIX_BUYER,
	API_PREFIX_SUPPLIER: API_PREFIX_SUPPLIER,
};
